import styled from "styled-components";
import {
  mobileAuthSideContainer,
  mobileAuthMainContainer,
} from "../../../styles/authShellMixins";

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: var(--app-bg-gradient);
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;

  ${mobileAuthMainContainer}
`;

export const SideContainer = styled.div`
  scrollbar-width: none;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  height: 100vh;
  min-height: 100vh;
  flex: 1 1 auto;
  width: ${({ collapsed }) =>
    collapsed === true || collapsed === "true"
      ? "calc(100% - 6vw)"
      : "calc(100% - 15vw)"};
  margin: 0;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  box-sizing: border-box;
  min-width: 0;

  &::-webkit-scrollbar {
    display: none;
  }

  ${mobileAuthSideContainer}
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 1.25rem 1.25rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  flex: 1 1 auto;
  min-width: 0;

  @media (max-width: 768px) {
    padding: 1rem 0.75rem 2rem;
  }
`;

export const Title = styled.h1`
  font-size: clamp(1.5rem, 4vw, 2.1rem);
  font-weight: 700;
  background: linear-gradient(
    135deg,
    var(--accent-secondary) 0%,
    var(--accent) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0.35rem 0 0.35rem;
  text-align: left;
  line-height: 1.25;
`;

export const AreaSubtitle = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-secondary);
  line-height: 1.4;
`;

export const HeaderSection = styled.header`
  text-align: left;
  margin-bottom: 0.9rem;
  width: 100%;
`;

export const TopBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 0.5rem;
`;

export const ActionsBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  margin-bottom: 1.25rem;
`;

/** Seção de dados — largura total, sem “balão” flutuante */
export const InfoSection = styled.section`
  width: 100%;
  border: 1px solid var(--border-default);
  border-radius: 14px;
  background: var(--surface-1);
  padding: 1.15rem 1.25rem 1.35rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem 0.9rem 1.15rem;
    border-radius: 12px;
  }
`;

export const InfoSectionTitle = styled.h2`
  margin: 0 0 1rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(160px, 240px) 1fr;
  gap: 1.25rem 1.75rem;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.9rem;
  }
`;

export const InfoFieldsColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 1.5rem;
  min-width: 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.9rem;
  }
`;

export const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;

  &[data-full="true"] {
    grid-column: 1 / -1;
  }
`;

export const InfoLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
`;

export const InfoValue = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.45;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const AdiImage = styled.img`
  display: block;
  width: 100%;
  max-width: 240px;
  height: auto;
  max-height: 220px;
  object-fit: contain;
  border-radius: 10px;
  border: 1px solid var(--border-default);
  background: var(--surface-2);

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 220px;
  }
`;

export const AdiImageEmpty = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-muted);
  padding: 1rem;
  border-radius: 10px;
  border: 1px dashed var(--border-default);
  background: var(--surface-2);
  text-align: center;
`;

export const TeamList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
`;

export const TeamChip = styled.li`
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
  background: var(--surface-2);
  border: 1px solid var(--border-default);
`;

export const StyledButton = styled.button`
  background: var(--accent-soft);
  border: 1px solid var(--border-default);
  border-radius: 999px;
  color: var(--text-heading);
  cursor: pointer;
  font-family: inherit;
  padding: 0.55rem 1.1rem;
  font-size: 0.88rem;
  font-weight: 600;
  min-height: 40px;

  &:hover {
    border-color: var(--accent);
  }
`;

export const StyledButtonForm = styled.button`
  background: ${({ secondary }) =>
    secondary ? "var(--surface-2)" : "var(--accent-soft)"};
  border: 1px solid var(--border-default);
  border-radius: 999px;
  color: var(--text-heading);
  cursor: pointer;
  font-family: inherit;
  padding: 0.5rem 0.95rem;
  font-size: 0.85rem;
  font-weight: 600;
  min-height: 40px;
  white-space: nowrap;

  &:hover:not(:disabled) {
    border-color: var(--accent);
  }

  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }
`;

export const FirmsSection = styled.section`
  margin-top: 1.5rem;
  width: 100%;
  border: 1px solid var(--border-default);
  border-radius: 14px;
  background: var(--surface-1);
  padding: 1.15rem 1.25rem 1.35rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem 0.9rem 1.15rem;
    border-radius: 12px;
  }
`;

export const FirmsSectionTitle = styled.h2`
  margin: 0 0 0.85rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
`;

export const FirmsCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.35rem;
`;

export const FirmsCard = styled.div`
  background: var(--surface-2);
  border: 1px solid var(--border-default);
  border-radius: 12px;
  padding: 1rem 1.1rem;
`;

export const FirmsCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
`;

export const FirmsCardName = styled.h3`
  font-size: 1.05rem;
  font-weight: 650;
  color: var(--text-primary);
  margin: 0;
`;

export const FirmsCardBbox = styled.p`
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin: 0 0 0.5rem 0;
  font-family: ui-monospace, monospace;
  word-break: break-all;
`;

export const FirmsCardStatus = styled.p`
  font-size: 0.9rem;
  color: var(--text-primary);
  margin: 0 0 0.75rem 0;
`;

export const FirmsCardActions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  button,
  a {
    flex: 1 1 auto;
    min-width: 120px;
  }
`;

export const FirmsCardMeta = styled.p`
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin: 0 0 0.35rem 0;
`;

export const FirmsCardLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  border-radius: 999px;
  color: var(--text-heading);
  cursor: pointer;
  font-family: inherit;
  padding: 0.5rem 0.95rem;
  font-size: 0.85rem;
  font-weight: 600;
  min-height: 40px;
  white-space: nowrap;
  text-decoration: none;
  box-sizing: border-box;

  &:hover {
    border-color: var(--accent);
  }
`;

export const FirmsEmpty = styled.p`
  color: var(--text-secondary);
  font-size: 0.95rem;
  padding: 0.35rem 0 0;
  text-align: left;
  margin: 0;
  line-height: 1.45;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  background: ${({ $danger }) =>
    $danger
      ? "color-mix(in srgb, var(--danger) 18%, transparent)"
      : "var(--accent-soft)"};
  color: ${({ $danger }) => ($danger ? "var(--danger)" : "var(--accent)")};
  border: 1px solid
    ${({ $danger }) => ($danger ? "var(--danger)" : "var(--accent)")};
`;

export const LoadingText = styled.p`
  color: var(--text-secondary);
  padding: 2rem 1rem;
`;

export const TabPanel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  flex: 1 1 auto;
  min-height: 0;
`;

/* Compat exports usados em outros imports legados (EditAreas etc. não usam este arquivo) */
export const Row = styled.div``;
export const Label = styled.label``;
export const RightColumn = styled.div``;
export const LeftColumn = styled.div``;
export const ShowInput = styled.input``;
export const StyledSelect = styled.select``;
export const FormContainer = styled.div``;
export const CardImage = styled.img``;
export const ButtonContainerRight = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
export const ButtonContainerLeft = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
export const TeamContainer = styled.div``;
export const TeamMember = styled.span``;
